import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useForm } from "react-hook-form";
import { toast } from "react-toastify";
import axios from "axios";
import { useSelector, useDispatch } from "react-redux";
import {
  Button,
  Chip,
  useDisclosure,
  Modal,
  ModalBody,
  ModalContent,
  ModalFooter,
  Select,
  SelectItem,
} from "@nextui-org/react";
import {
  getDisputeTitle,
  getCancelReason,
} from "../../store/slices/adminSlice";
import { refreshIfNeeded } from "../../store/actions/refreshIfNeeded";

const OrderGenerate = ({ orderData, showButton }) => {
  const { register, handleSubmit } = useForm();
  const { disputeTitle, cancelReason } = useSelector((state) => state.admin);
  const role = localStorage.getItem("role");
  const {
    isOpen: disputeOpen,
    onOpen: onDispute,
    onClose: closeDispute,
  } = useDisclosure();
  const { quote } = useSelector((state) => state.customer);
  const {
    isOpen: cancelModal,
    onOpen: onCancel,
    onClose: closeModal,
  } = useDisclosure();
  const [supplier, setSupplier] = useState();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [multipleOffer, setMultipleOffer] = useState([]);
  const openDisputeWithAuth = async () => {
    await dispatch(refreshIfNeeded());
    onDispute();
  };
  const openCancelWithAuth = async () => {
    await dispatch(refreshIfNeeded());
    onCancel();
  };
  const authHeaders = () => ({
    headers: { authorization: `Bearer ${localStorage.getItem("accessToken")}` },
  });

  const ensureAuth = async () => {
    await dispatch(refreshIfNeeded());
    return authHeaders();
  };
  const onSubmit = (data) => {
    const { title } = data;
    closeDispute();
    let reason_data = {
      title: title,
      titleReason: disputeTitle.filter((item) => item.id === title)[0]?.name,
      make: orderData?.Request?.VehicleMake?.name
        ? orderData?.Request?.VehicleMake?.name
        : orderData?.Request?.custom_make,
      model: orderData?.Request?.VehicleModel?.name
        ? orderData?.Request?.VehicleModel?.name
        : orderData?.Request?.custom_model,
      part: orderData?.Request?.Part?.name
        ? orderData?.Request?.Part?.name
        : orderData?.Request?.custom_part_type,
    };
    localStorage.setItem("reason_data", JSON.stringify(reason_data));
    setTimeout(() => {
      navigate(`/dispute-details/${orderData?.id}`);
    }, 700);
  };

  const handleCancel = async (data) => {
    try {
      const headers = await ensureAuth();
      const res = await axios.patch(
        `${process.env.REACT_APP_SERVER_URL}/orders/${orderData.id}/cancel`,
        data,
        headers
      );

      toast.success(res.data.message);
      closeModal();
      window.location.reload();
    } catch (error) {
      let err = error.response?.data?.message;
      toast.error(err);
    }
  };

  const getSupplierInfo = async (id) => {
    if (id) {
      try {
        const headers = await ensureAuth();
        const res = await axios.get(
          `${process.env.REACT_APP_SERVER_URL}/users/profile/${id}`,
          headers
        );

        let data = res?.data?.details?.user;
        setSupplier(data);
      } catch (error) {
        let err = error?.response?.data?.message;
        toast.error(err);
      }
    }
  };

  useEffect(() => {
    (async () => {
      await dispatch(refreshIfNeeded());
      dispatch(getDisputeTitle());
      dispatch(getCancelReason());
    })();
  }, [dispatch]);

  useEffect(() => {
    if (role === "CUSTOMER") {
      if (orderData) {
        getSupplierInfo(orderData.supplier_id);
        if (orderData?.Quote?.QuoteOptions?.length > 0) {
          let offers = orderData?.Quote?.QuoteOptions;
          let trueOffers = offers.filter((offers) => offers?.approval === true);
          setMultipleOffer(trueOffers);
        }
      }
    }
  }, [orderData]);
  // console.log("Order Status:", orderData);

  return (
    <div>
      {role === "CUSTOMER" && (
        <div className="mt-7">
          <p className="font-semibold pb-2 text-base border-b-1 border-gray-300 ">
            Supplier Details
          </p>
          <div className="pt-3">
            <div className="grid sm:grid-cols-4 items-center">
              <div className="sm:block flex justify-center mb-3 sm:mb-0">
                <img
                  className="rounded-full w-28 sm:w-40 h-28 sm:h-40 text-center"
                  src={supplier?.profile_id}
                  alt="supplier"
                />
              </div>
              <div className="sm:col-span-3 text-xs sm:text-sm">
                <div className="grid gap-4 grid-cols-2 justify-between [&>p>span:first-child]:font-semibold">
                  <p className="capitalize">
                    <span>Names: </span>
                    <span>
                      {supplier?.first_name + " " + supplier?.last_name}
                    </span>
                  </p>
                  <p>
                    <span>Phone Number: </span>
                    <span>{supplier?.phone}</span>
                  </p>
                  <p className="capitalize">
                    <span>Email: </span>
                    <span></span>
                    {supplier?.email}
                  </p>
                  <p className="capitalize">
                    <span>Company Name: </span>
                    <span>{supplier?.company_name}</span>
                  </p>
                </div>
                <p className="mt-4  capitalize">
                  <span className="font-semibold">Address:</span>
                  <span>{supplier?.address_line_1}</span>{" "}
                </p>
              </div>
            </div>
          </div>
        </div>
      )}

      <div className="mt-7">
        <p className="font-semibold pb-2 text-base border-b-1 border-gray-300 ">
          Your Order Details
        </p>
        <div className="my-7 border-1 border-gray-300 rounded-lg md:grid md:grid-cols-5 shadow-inner">
          <div className="col-span-4 border-b-1 sm:border-r-1 border-gray-200">
            <div className="flex justify-between items-center py-2 md:py-3 px-3 md:px-5 border-b-1 border-gray-200">
              <p className="text-sm font-semibold">
                <span>Tracking Number : </span>
                <span className="text-red-500">
                  {orderData?.tracking_number}
                </span>
                {/* {console.log("orderdata", orderData)} */}
              </p>
              <div className="flex">
                <Chip
                  color={
                    orderData?.OrderStatus?.status === "Completed"
                      ? "success"
                      : orderData?.OrderStatus?.status === "Delivered"
                      ? "success"
                      : orderData?.OrderStatus?.status === "Shipped"
                      ? "secondary"
                      : orderData?.OrderStatus?.status === "Processing"
                      ? "warning"
                      : orderData?.OrderStatus?.status === "Initiated"
                      ? "primary"
                      : orderData?.OrderStatus?.status === "Cancelled"
                      ? "danger"
                      : orderData?.OrderStatus?.status === "Dispute"
                      ? "danger"
                      : "border-purple-600 bg-purple-300"
                  }
                  variant="dot"
                  className={`border-2 ${
                    orderData?.OrderStatus?.status === "Completed"
                      ? "border-[#3BB07B] bg-[#a7e2c7] text-green-700"
                      : orderData?.OrderStatus?.status === "Delivered"
                      ? "border-[#3BB07B] bg-[#a7e2c7] text-green-700"
                      : orderData?.OrderStatus?.status === "Shipped"
                      ? "border-[#9D53CF] text-purple-600 bg-[#E4D4F4]"
                      : orderData?.OrderStatus?.status === "Processing"
                      ? "border-[#DBA84B] text-[#DBA84B] bg-[#F4E4CB]"
                      : orderData?.OrderStatus?.status === "Initiated"
                      ? "border-[#5B86F0] text-blue-600 bg-[#CCE2FC]"
                      : orderData?.OrderStatus?.status === "Cancelled"
                      ? "border-[#F33F7B] text-[#F33F7B] bg-[#F4C7D7]"
                      : orderData?.OrderStatus?.status === "Dispute"
                      ? "border-[#F32B6A] text-[#F32B6A] bg-[#FDD0DF]"
                      : "border-purple-600 bg-purple-300"
                  }`}
                >
                  {orderData?.OrderStatus?.status || "No Status"}
                </Chip>

                {orderData?.Quote?.Payments?.at(-1)?.paymentMethod && (
                  <Chip
                    color="success"
                    variant="dot"
                    className="float-right bg-green-300 border-2 border-green-700 text-green-900  ml-2"
                  >
                    <p>{orderData?.Quote?.Payments?.at(-1)?.paymentMethod}</p>
                  </Chip>
                )}
              </div>
            </div>
            <div className="p-7 sm:p-3 md:p-5">
              <div className="grid sm:grid-cols-3 gap-1 ">
                <div className="!mt-0 order-generation-text">
                  <p>
                    <span>Name : </span>
                    <span>
                      {orderData?.Request?.User?.first_name &&
                      orderData?.Request?.User?.last_name
                        ? `${orderData.Request.User.first_name} ${orderData.Request.User.last_name}`
                        : "Not Provided"}
                    </span>
                  </p>
                  <p className="capitalize">
                    <span>Make : </span>
                    <span>
                      {orderData?.Request?.VehicleMake?.name
                        ? orderData?.Request?.VehicleMake?.name.toLowerCase()
                        : orderData?.Request?.custom_make.toLowerCase()}
                    </span>
                  </p>
                  <p className="capitalize">
                    <span>Modal : </span>
                    <span>
                      {orderData?.Request?.VehicleModel?.name
                        ? orderData?.Request?.VehicleModel?.name.toLowerCase()
                        : orderData?.Request?.custom_model}
                    </span>
                  </p>
                  <p className="capitalize">
                    <span>Part : </span>
                    <span>
                      {orderData?.Request?.Part?.name
                        ? orderData?.Request?.Part?.name || "Not Provided"
                        : orderData?.Request?.custom_part_type ||
                          "Not Provided"}
                    </span>
                  </p>
                  <p className="capitalize">
                    <span>Quantity : </span>
                    <span>{orderData?.Request?.quantity} Qnty</span>
                  </p>
                  {orderData?.Request?.rego ? (
                    <p className="capitalize">
                      <span>Rego : </span>
                      <span>{orderData.Request.rego}</span>
                    </p>
                  ) : orderData?.Request?.vin ? (
                    <p className="capitalize">
                      <span>VIN : </span>
                      <span>{orderData.Request.vin}</span>
                    </p>
                  ) : orderData?.Request?.prof_descreption ? (
                    <p className="capitalize">
                      <span className="font-semibold block mb-1">
                        Description:
                      </span>
                      <span className="block max-h-24 overflow-y-auto overflow-x-hidden p-1 bg-gray-100 rounded text-sm border border-gray-300 whitespace-pre-line">
                        {orderData?.Request?.prof_descreption || "Not Provided"}
                      </span>
                    </p>
                  ) : (
                    <p className="capitalize">
                      <span>Rego : </span>
                      <span>Not Provided</span>
                    </p>
                  )}

                  <p className="capitalize">
                    <span>Fuel Type : </span>
                    <span>
                      {orderData?.Request?.fuelType?.name || "Not Provided"}
                    </span>
                  </p>
                  <p className="capitalize">
                    <span>Sales Rep : </span>
                    <span>
                      {orderData?.Quote?.SupplierSalesRep?.SalesRepName}
                    </span>
                  </p>
                  <p>
                    <span className="font-semibold ">Shipping Address : </span>
                    <span>
                      {orderData?.Request?.User?.address_line_1 ||
                      orderData?.Request?.User?.address_line_2
                        ? `${orderData?.Request?.User?.address_line_1 || ""} ${
                            orderData?.Request?.User?.address_line_2 || ""
                          }`.trim()
                        : "Not Provided"}
                    </span>
                  </p>
                </div>
                <div className="order-generation-text">
                  <p>
                    <span>Phone Number : </span>
                    <span>
                      {orderData?.Request?.User?.phone || "Not Provided"}
                    </span>
                  </p>
                  <p>
                    <span>Part Price : </span>
                    <span>${orderData?.Quote?.part_price}</span>
                  </p>
                  <p>
                    <span>Freight Price : </span>
                    <span>${orderData?.Quote?.freight_price}</span>
                  </p>
                  <p>
                    <span>Total Price (Inc GST) : </span>
                    <span>${orderData?.Quote?.total_price}</span>
                  </p>
                  <p className="capitalize">
                    <span>Warranty : </span>
                    <span>
                      {orderData?.Quote?.warrantyDuration?.duration}{" "}
                      {orderData?.Quote?.warrantyDuration?.unit}
                    </span>
                  </p>
                  <p className="capitalize">
                    <span>Body Style : </span>
                    <span>
                      {orderData?.Request?.bodyStyle?.name || "Not Provided"}
                    </span>

                    {/* {console.log("orderData?.Request",orderData?.Request?.bodyStyle)}     */}
                  </p>
                  <p>
                    <span>Warranty Price : </span>
                    <span>
                      {orderData?.Quote?.warranty_price != null
                        ? orderData?.Quote?.warranty_price
                        : "Not provided"}
                    </span>
                  </p>
                  <p>
                    <span className="font-semibold">Warranty Option : </span>
                    <span>{orderData?.Quote?.warranty_option}</span>
                    {/* <span>
                      {orderData?.Quote?.warranty_option
                        ? orderData?.Quote?.warranty_option
                        : "Not provided"}
                    </span> */}
                  </p>

                  {/* <p>
                    <span className="font-semibold ">Post Code : </span>
                    <span>
                      {orderData?.Request?.User?.postcode || "Not Provided"}
                    </span>
                  </p> */}
                </div>
                <div className="order-generation-text">
                  <p>
                    <span>Capricorn Number : </span>
                    <span>
                      {orderData?.Request?.User?.capricorn_number ||
                        "Not Provided"}
                    </span>
                  </p>
                  <p className="capitalize">
                    <span>Transmission : </span>
                    <span>
                      {orderData?.Request?.transmissionModel?.name.toLowerCase() ||
                        "Not Privided"}
                    </span>
                  </p>
                  <p className="capitalize">
                    <span>Tracking Carrier : </span>
                    <span>
                      {orderData?.tracking_carrier?.toLowerCase() ||
                        "Not Provided"}
                    </span>
                  </p>

                  <p>
                    <span>Shipping Date : </span>
                    {/* <span>{orderData?.date_ship?.split("T")[0] || "Not Privided"}</span> */}
                    <span>
                      {orderData?.date_ship
                        ? new Date(orderData?.date_ship).toLocaleDateString(
                            "en-GB"
                          )
                        : "Not Provided"}
                    </span>
                  </p>
                  <p>
                    <span>Order Date : </span>
                    {/* <span>{orderData?.date_ordered?.split("T")[0] || "Not Privided"}</span> */}
                    <span>
                      {orderData?.date_ordered
                        ? new Date(orderData?.date_ordered).toLocaleDateString(
                            "en-GB"
                          )
                        : "Not Provided"}
                    </span>
                  </p>
                  {/* <p className="capitalize">
                    <span>Body Style : </span>
                    <span>
                      {orderData?.Request?.bodyStyle?.name || "Not Provided"}
                    </span> */}

                  {/* {console.log("orderData?.Request",orderData?.Request?.bodyStyle)}     */}
                  {/* </p> */}
                  <p>
                    <span>Business Name : </span>

                    <span>
                      {/* {orderData?.Quote?.User?.business_name || `${quote?.User?.first_name} ${quote?.User?.last_name}`} */}
                      {orderData?.Request?.User?.business_name ||
                        (quote?.User?.first_name && quote?.User?.last_name
                          ? `${orderData?.Quote?.User?.first_name} ${orderData?.Quote?.User?.last_name}`
                          : `${orderData?.Quote?.User?.first_name} ${orderData?.Quote?.User?.last_name}`.trim())}
                    </span>
                    {/* {console.log("Business Name from backend:", `${quote?.User?.first_name} ${quote?.User?.last_name}`)} */}
                    {console.log(
                      "OrderDataDetail:",
                      orderData?.Request?.User?.business_name
                    )}
                    {/* {console.log("Last Name:", orderData?.Quote?.User?.last_name)} */}
                  </p>
                  <p>
                    <span className="font-semibold ">Country: </span>
                    <span>
                      {orderData?.Request?.User?.country || "Not Provided"}
                    </span>
                  </p>
                  <p>
                    <span className="font-semibold ">City: </span>
                    <span>
                      {orderData?.Request?.User?.city || "Not Provided"}
                    </span>
                  </p>
                  <p>
                    <span className="font-semibold ">Post Code : </span>
                    <span>
                      {orderData?.Request?.User?.postcode || "Not Provided"}
                    </span>
                  </p>
                </div>
              </div>
            </div>
          </div>

          <div className="font-semibold flex  justify-center items-center ">
            {orderData?.OrderStatus?.status === "Dispute" ? (
              <div className="text-sm font-semibold text-red-500 p-2">
                Order disputed
              </div>
            ) : orderData?.OrderStatus?.status === "Cancelled" ? (
              <Button className="bg-lightBlue text-white px-10">
                {role === "CUSTOMER" ? "Request Credit" : "Initiate Refund"}
              </Button>
            ) : (
              <div className="flex flex-col sm:flex-row md:flex-col gap-3 justify-center py-4 md:py-0 font-semibold">
                {showButton && (
                  <Link to={`/orders/${orderData.id}`}>
                    <Button className="bg-lightBlue text-white px-10">
                      Check Order
                    </Button>
                  </Link>
                )}
                <Button
                  className="bg-[#FDCDC3] text-[#F53269] px-9"
                  onClick={openDisputeWithAuth}
                >
                  Dispute Order
                </Button>
                {orderData?.OrderStatus?.status !== "Delivered" &&
                  orderData?.OrderStatus?.status !== "Completed" && (
                    <Button
                      className="bg-lightBlue text-white px-10"
                      onClick={openCancelWithAuth}
                    >
                      Cancel Order
                    </Button>
                  )}
              </div>
            )}
          </div>
        </div>
        <Modal
          size={"sm"}
          isOpen={disputeOpen}
          onClose={closeDispute}
          className="p-3"
          placement="center"
        >
          <ModalContent>
            {(closeDispute) => (
              <>
                <form
                  onSubmit={(event) => {
                    event.preventDefault();
                    event.stopPropagation();
                    handleSubmit(onSubmit)(event);
                  }}
                >
                  <ModalBody className="w-full">
                    <p className="text-base font-semibold text-center">
                      Are you sure?
                    </p>
                    <Select
                      labelPlacement={"outside"}
                      variant={"bordered"}
                      label="Select the Reason"
                      placeholder="Select reason"
                      className="w-full"
                      {...register("title", { required: true })}
                    >
                      {disputeTitle?.map(
                        (item) =>
                          item?.id !== 0 &&
                          item?.id !== -1 && (
                            <SelectItem key={item.id}>{item.name}</SelectItem>
                          )
                      )}
                    </Select>
                  </ModalBody>
                  <ModalFooter className="p-3 mt-4 justify-normal">
                    <div className="grid grid-cols-2 gap-4 w-full">
                      <Button
                        className="w-full bg-purpleBtn font-semibold text-white"
                        onClick={closeDispute}
                      >
                        Close
                      </Button>
                      <Button
                        type="submit"
                        className="w-full bg-lightBlue font-semibold text-white"
                      >
                        Submit
                      </Button>
                    </div>
                  </ModalFooter>
                </form>
              </>
            )}
          </ModalContent>
        </Modal>
        {/* ----- modal for cancel ---- */}
        <Modal
          size={"sm"}
          isOpen={cancelModal}
          onClose={closeModal}
          className="p-3"
          placement="center"
        >
          <ModalContent>
            {(closeModal) => (
              <>
                <form
                  onSubmit={(event) => {
                    event.preventDefault();
                    event.stopPropagation();
                    handleSubmit(handleCancel)(event);
                  }}
                >
                  <ModalBody className="w-full !px-3">
                    <p className="text-base font-semibold text-center">
                      Are you sure?
                    </p>
                    <Select
                      labelPlacement={"outside"}
                      variant={"bordered"}
                      label="Select the Reason"
                      placeholder="Select reason"
                      className="w-full"
                      {...register("cancel_reason", { required: true })}
                    >
                      {cancelReason?.map(
                        (item) =>
                          item?.id !== 0 && (
                            <SelectItem key={item.id}>{item.name}</SelectItem>
                          )
                      )}
                    </Select>
                  </ModalBody>
                  <ModalFooter className="p-3 mt-4 justify-normal">
                    <div className="grid grid-cols-2 gap-4 w-full">
                      <Button
                        className="w-full bg-purpleBtn font-semibold text-white"
                        onClick={closeModal}
                      >
                        Cancel
                      </Button>
                      <Button
                        type="submit"
                        className="w-full bg-lightBlue font-semibold text-white"
                      >
                        Submit
                      </Button>
                    </div>
                  </ModalFooter>
                </form>
              </>
            )}
          </ModalContent>
        </Modal>
      </div>
    </div>
  );
};

export default OrderGenerate;
